module.exports = __webpack_public_path__ + "static/avatar_shoaib-cffb89c60423f788373d25833ac3e922.png";